module.exports = __webpack_public_path__ + "fonts/figtree-latin-normal-300-900.woff2";